// App.tsx
import React from 'react';
import { motion } from 'framer-motion';
import './App.css';

const App: React.FC = () => {
  return (
    <div className="App">
      <motion.header
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="header"
      >
        <h1>SWAT Group</h1>
        <p>Co-Founder: Kiyan SWAT</p>
      </motion.header>

      <section className="about">
        <motion.div
          initial={{ opacity: 0, x: -100 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h2>About SWAT</h2>
          <p>SWAT is a diverse group company with expertise in various sectors.</p>
        </motion.div>
      </section>

      <section className="divisions">
        <h2>Our Divisions</h2>
        <motion.div
          className="division-cards"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 1 }}
        >
          <div className="card">
            <h3>Freelancer</h3>
            <p>Connecting freelancers with top clients.</p>
          </div>
          <div className="card">
            <h3>Head Hunt</h3>
            <p>Expert recruitment solutions.</p>
          </div>
          <div className="card">
            <h3>Store</h3>
            <p>A wide range of quality products.</p>
          </div>
          <div className="card">
            <h3>Blockchain</h3>
            <p>Innovative blockchain solutions.</p>
          </div>
          <div className="card">
            <h3>Web Design</h3>
            <p>Creating stunning digital experiences.</p>
          </div>
          <div className="card">
            <h3>Build Website</h3>
            <p>End-to-end web development services.</p>
          </div>
        </motion.div>
      </section>

      <motion.footer
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.2 }}
        className="footer"
      >
        <h2>Contact Us</h2>
        <p>Email: info@swatgroup.com</p>
      </motion.footer>
    </div>
  );
};

export default App;
